import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import * as Icons from '../Icons';
import { getCookie } from '../../helpers';
const Container = styled.div `
  height: 60pt;
  width: 128pt;
  background: #0d1e2e;
  border-radius: 6pt;
  padding-top: 4pt;
  padding-left: 4pt;
  padding-right: 4pt;
  display: none;
  cursor: pointer;
  user-select: none;
`;
const Center = styled.div `
  display: flex;
  flex-direction: row;
  height: 35pt;
  background: #f8f8f8;
  border-radius: 4pt;
`;
const IconWrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-right: 1pt solid #d2d2d2;
  width: 150pt;
  padding-bottom: 2pt;
  span {
    font-style: normal;
    font-weight: 600;
    font-size: 4pt;
    line-height: 5pt;
    text-align: center;
    color: #0d1e2e;
  }
`;
const Info = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 7pt;
  background: #ffffff;
  border-radius: 4pt;

  span {
    font-style: normal;
    font-weight: 600;
    font-size: 4pt;
    line-height: 5pt;
    text-align: center;
    color: #0d1e2e;
  }
`;
const Bottom = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${({ language }) => (language === 'nl' ? '6pt 2pt' : '6pt 10pt')};

  span {
    font-style: normal;
    font-weight: normal;
    font-size: 6pt;
    line-height: 9pt;
    text-align: center;
    color: #ffffff;
  }

  svg {
    margin-top: 1.5pt;
  }
`;
const Stamp = ({ stampRef, className }) => {
    const language = getCookie('lang');
    return (React.createElement(Container, { className: className, ref: stampRef },
        React.createElement(Center, null,
            React.createElement(IconWrapper, null,
                React.createElement(Icons.IconElectronicSignature, null),
                React.createElement(FormattedMessage, { id: "Stamp.qualifiedElectronicSiqText", defaultMessage: "Kwalifikowany podpis elektroniczny" })),
            React.createElement(Info, null,
                React.createElement(FormattedMessage, { id: "Stamp.placeholder", defaultMessage: "W tym miejscu zostan\u0105 umieszczone Twoje dane oraz data i godzina z\u0142o\u017Cenia podpisu" }))),
        React.createElement(Bottom, { language: language },
            React.createElement(FormattedMessage, { id: "Stamp.bottom", defaultMessage: "Podpisano na platformie" }),
            React.createElement(Icons.IconAutenti, null))));
};
export default Stamp;
